import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { Heading, Text } from '../../util/typography';
import * as CTA from '../../util/CTA';
import * as color from '../../util/colors';
import { NAVIGATION_BREAKPOINT } from '../../constants/layout';
import * as colors from "../../util/colors";
import { H5 } from '../../util/typography/Heading';
import { UnderlineTransitionHover } from '../../util/typography/Text';

const bp = NAVIGATION_BREAKPOINT

const Container = styled.div`
  height:100%;
  width:100%;
  display: flex;
  padding: 30px 0;
  border-radius: 8px;
  border: 1px solid #70199F;
  transition: 0.3s;
  border-radius: 8px;
  background: linear-gradient(108deg, #7C02BB 2.34%, #630198 26.76%, #4A0075 70.7%, #630198 88.73%, #7C02BB 100%);
  z-index: 0;
  flex-direction: column;
  align-items: center;
  // justify-content: center;
  align-self: stretch;
  position: relative;
  overflow: hidden;
  cursor: pointer;
  &:hover {
        box-shadow: 0 0 20px rgba(0, 0, 0, 0.35);
        border: 1px solid #c8c7c8 !important;

        a {
        color: ${color.blueberryDark};
        background-position: right center;
        span::before {
          ${UnderlineTransitionHover}
          }
        }
    }
  // @media (min-width:${bp}){
  //  min-height: 567px;
  //  }
  @media (max-width:${bp}){
  padding: 30px 0 30px;
}
`;
const BackgroundImgCont = styled.a`
  // background-image: url("/static/images/SubQBG.png");
  height:100%;
  width: 100%;
  display: flex;
  // padding: 30px 20px;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  text-decoration: none;
  background-size: 100% 100%; 
  background-position: center;    
  background-repeat: no-repeat; 
  // &:hover > div > span:last-child {
  // text-decoration: underline;
  // text-decoration-color: ${color.white};
  // text-decoration-thickness: 2px; 
  // transition: 0.3s text-decoration ease-in-out;
  // text-underline-offset: 2px;
  // }
`;
const ContentCont = styled.div`
display: flex;
flex-direction: column;
align-items: center;
justify-content: center;
// gap: 16px;
align-self: stretch;
position: relative;
`;

const TertiaryButton = styled(CTA.TertiaryButton)`
color: ${color.white};
>span {
padding: 0;
  }
&:hover, &:active, &:focus {
  color: ${color.white};
}
&:after {
  background-image: url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMC40MSIgaGVpZ2h0PSIxMC4xMyIgZmlsbD0iIzAwNmVhZCI+CiAgICA8cGF0aCBkPSJNNS4zNCAxMC4xM0wzLjkzIDguNzFsMi42NS0yLjY1SDB2LTJoNi41OEwzLjkzIDEuNDEgNS4zNCAwbDUuMDcgNS4wNi01LjA3IDUuMDd6IiBmaWxsPSIjMDA2ZWFkIiAvPgo8L3N2Zz4K), linear-gradient(to right, #ffffff 0%, #ffffff 50%, #ffffff calc(50% + 1px), #ffffff 100%);
}
`;
const StyledContent = styled(Heading.H7)`
text-align: center;
color: ${color.white};
margin: 20px 20px;
line-height: 20px;
font-weight:400;

.mb-16{
padding-bottom: 16px;
display:block;
}
@media (max-width: ${bp}){
margin: 20px;
}
`;
const StyledHeading = styled.div`
  display:flex;
  justify-content: center;
  align-items: center;
  padding: 8px 15px;
  height: 33px;
  color: ${color.white};
  border-radius: 4px;
  background: linear-gradient(120deg, #2C6D3C, #48a446);
  z-index: 1;
  span {
    color: ${color.white};
    font-size: 14px;
    font-weight: 500;
    line-height: normal;
    margin-bottom: -1px;
    leading-trim: both;
    text-edge: cap;
  }
  @media (max-width: ${bp}){
    top: 30px;
  }
`;

const Button = styled(CTA.PrimaryButton)`
// position: absolute;
// bottom: 30px;

// @media (max-width: ${bp}){
// position: unset;
// }
`;
const ImageWrapper = styled.div`
width: 100%;
display: flex;
padding: 35px 43.725px 21.05px 43px;
justify-content: center;
align-items: center;
background: #FFF;
box-shadow: 0px 0px 25px 10px #4A0075;
margin-top: -17px;
`;

const StyledImg = styled.img`
// object-fit: cover;
width: 229.275px;
height: 50.95px;
`;

const ContentWrapper = styled.div`
  height:auto;
  width:100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  `;

const CustomHomePageGridSubQ = ({heroSubQ}) => {
      const [isClient, setIsClient] = useState(null); //test purpose

      const handleRender = () =>{
        setIsClient(window.innerWidth);
      }
      const handleCardClick = () => {
        window.location.href='/qlex/';
      }
 
//Test purpose start
    useEffect(() => {
      if(typeof window === undefined) return;

      window.addEventListener("load",handleRender)
      handleRender();
      return () =>{
        window.removeEventListener("load", handleRender)
      }
    }, []);
//test purpose end

  return (
<Container key={`Qsub-${isClient}`} data-design-category="button_vd" onClick={()=> handleCardClick() }>    
  <ContentWrapper>
    <StyledHeading><span>{heroSubQ.headerText}</span></StyledHeading>
    <ImageWrapper>
      <StyledImg src={heroSubQ.subQicon} alt={heroSubQ.subQAltText || ""} />
      {/* <StyledHeading><span>{heroSubQ.headerText}</span></StyledHeading> */}
    </ImageWrapper>             
  </ContentWrapper> 
  <StyledContent>{heroSubQ.content}</StyledContent>
  <Button theme="light" url = "/qlex/" label={heroSubQ.buttonLabel} />
</Container>
  )
}
export default CustomHomePageGridSubQ;